@if (isExpLabelShow()) {
  <div class="experience-content">
    @if(isEmploymentHistoryView){
      @if (experience()?.workHistories?.length > 0) {
        <h2>Experience</h2>
      }
      @if (experience()?.workHistories?.length > 0) {
        <h3>Work History</h3>
      }
      @for (item of experience()?.workHistories; track $index) {
        <div class="experience-item">
          <label class="job-title"
            >{{ item.jobTitle
            }}{{
            item.company != '' && item.company != null ? ', ' + item.company : ''
            }}</label
            >
            <label class="work-date"
              >{{ item.jobDurationDateFrom | date : 'MMMM yyyy' }} -
              @if(item.isPresentlyWorking) { Present } @else{
                {{ item.jobDurationDateTo | date : 'MMMM yyyy' }}
              }
            </label>
            <div [innerHTML]="item.dutiesAndResponsibilities" class="tinymce"></div>
          </div>
          } } @if(isReferencesView){
          @if (experience()?.references?.length > 0) {
            <h3>Character References</h3>
          }
          @for (item of experience()?.references; track $index) {
            <div class="reference-item">
              <label class="character-name">{{ item.name }}</label>
              <label class="character-position"> {{ item.relationshipLabel }} </label>
              <div class="character-contacts">
                @if(item.contactNumber !== null){
                  <label>
                    <i class="fa-regular fa-phone"></i> {{ item.contactNumber }}
                  </label>
                  } @if(item.charRefEmail !== null){
                  <label>
                    <i class="fa-regular fa-envelope"></i> {{ item.charRefEmail }}
                  </label>
                }
              </div>
            </div>
            } } @if(isSeminarView){
            @if (experience()?.seminarConferenceCourses?.length > 0) {
              <h3>
                Seminar, Conferences and Courses
              </h3>
            }
            @for (item of experience()?.seminarConferenceCourses; track $index) {
              <div class="seminar-item">
                <label class="seminar-name"> {{ item.title }} </label>
                <label class="seminar-date">{{
                  item.dateAttended | date : 'dd MMMM yyyy'
                }}</label>
                <p class="seminar-summary">
                  {{ item.description }}
                </p>
              </div>
              } } @if(isPublicationsView){
              @if (experience()?.publications?.length > 0) {
                <h3>Publications</h3>
              }
              @for (item of experience()?.publications; track $index) {
                <div class="publication-item">
                  <label class="publication-title">{{ item.title }}</label>
                  <label class="publication-date">{{
                    item.datePublished | date : 'dd MMMM yyyy'
                  }}</label>
                  <p class="publication-summary">
                    {{ item.description }}
                  </p>
                </div>
                } } @if(isAffiliationsView){
                @if (experience()?.affiliations?.length > 0) {
                  <h3>Affiliations</h3>
                }
                @for (item of experience()?.affiliations; track $index) {
                  <div class="affiliations-item">
                    <label class="affiliations-title">{{ item.name }}</label>
                    <label class="affiliations-date">{{
                      item.dateAffiliated | date : 'dd MMMM yyyy'
                    }}</label>
                    <p class="affiliations-summary">
                      {{ item.description }}
                    </p>
                  </div>
                  } }
                </div>
              }
